module.exports = __webpack_public_path__ + "img/LT112046049.08d90259.png";